import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { DefaultLayout } from "../../../../layouts/Default";
import { Main } from "../../../../themes/Default/components/Main";
import { TopNavigation } from "../../../../themes/Default/components/TopNavigation";
import { Breadcrumps } from "../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../themes/Default/components/Breadcrumps/components/Link";
import { Button, ButtonBack } from "../../../../themes/Default/components/TopNavigation/components/Button";
import { Form } from "../../../../themes/Default/components/Form";
import { Row } from "../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../themes/Default/components/Form/components/Input";
import { locationsManagement } from "../../../../hooks/api/LocationsManagement";
import { employeesManagement } from "../../../../hooks/api/EmployeesManagement/EmployeesManagement";
import { useTranslation } from "react-i18next";
import { Tabs } from "../../../../themes/Default/components/Tabs";
import { prepareSelect } from "../../../../services/core/Select";
import { Select } from "../../../../themes/Default/components/Form/components/Select";
import Divider from "../../../../themes/Default/components/Divider/Divider";

const AddLocation = () => {
    const { t } = useTranslation("common");
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [formErrors, setFormErrors] = useState([]);
    const { useAddLocationMutation } = locationsManagement;
    const [addLocations, { isLoading: isAddingStudent }] = useAddLocationMutation();
    const { useEmployeesListMutation } = employeesManagement;
    const [employeesList] = useEmployeesListMutation();
    const [employees, setEmployees] = useState([]);

    const tabs = [
        { title: t("locations.title"), isActive: true },
        { title: t("legalEntity.title"), onClick: () => gotoLegalEntityTab() },
    ];

    const gotoLegalEntityTab = () => {
        navigate("/settings/locations/legal-entities");
    }
    
    const onSave = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onSaved = (values) => {
        if (values?.contactPerson === "") {
            values.contactPerson = null;
        }
        addLocations(values).then((result) => {            
            if (result?.error) {
                setFormErrors(result?.error?.data?.error?.violations);
                toast.error(result.error.data.error.responseMessage);
            } else {
                navigate("/settings/locations/locations");
            }
        });
    };

    useEffect(() => {
        employeesList().then((result) => {
                let options = [];
                result?.data?.records.map((employee) => {
                    options.push({
                        id: employee.id,
                        name: `${employee.firstName} ${employee.lastName}`,
                    });
                });
                setEmployees(prepareSelect(options));
            });
    }, []);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings/locations/locations" />
                <Button title={t("save")} isDisabled={isAddingStudent} icon="fa-regular fa-floppy-disk" onClick={onSave}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
            <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("locations.title")} />
                    <Link title={t("locations.title")} />
                    <Link title={t("locations.addLocation")} isActive={true} />
                </Breadcrumps>
                <Formik
                    innerRef={formRef}
                    initialValues={{
                        name: "",
                        address: "",
                        phoneNumber: "",
                        contactPerson: "",
                        workingHoursFrom: "",
                        workingHoursTo: "",
                        transportationLines: ""
                    }}
                    onSubmit={onSaved}
                >
                    {({ values, handleChange }) => (
                        <Form>
                            <Row>
                                <Field>
                                    <Input
                                        name="name"
                                        label={t("locations.name")}
                                        required={true}
                                        value={values.name}
                                        onChange={handleChange}
                                        error={formErrors?.name}
                                    />
                                </Field>
                                <Field>
                                    <Input
                                        name="address"
                                        label={t("locations.address")}
                                        required={true}
                                        value={values.address}
                                        onChange={handleChange}
                                        error={formErrors?.address}
                                    />
                                </Field>
                            </Row>
                            <Row>
                                <Field>
                                    <Input
                                        name="phoneNumber"
                                        label={t("locations.phoneNumber")}
                                        required={true}
                                        value={values.phoneNumber}
                                        onChange={handleChange}
                                        error={formErrors?.phoneNumber}
                                    />
                                </Field>
                                <Field>
                                    <Select
                                        name="contactPerson"
                                        label={t("locations.contactPerson")}
                                        options={employees}
                                        onChange={handleChange}
                                        selectedValue={values.contactPerson}
                                        error={formErrors?.contactPerson}
                                    />
                                </Field>
                            </Row>
                            <Row>
                                <Field>
                                    <Input
                                        name="workingHoursFrom"
                                        label={t("locations.workingHoursFrom")}
                                        value={values.workingHoursFrom}
                                        onChange={handleChange}
                                        error={formErrors?.workingHoursFrom}
                                    />
                                </Field>
                                <Field>
                                    <Input
                                        name="workingHoursTo"
                                        label={t("locations.workingHoursTo")}
                                        value={values.workingHoursTo}
                                        onChange={handleChange}
                                        error={formErrors?.workingHoursTo}
                                    />
                                </Field>
                            </Row>
                            <Divider title={t("additionalInformation")} />
                            <Row>
                                <Field isFullWidth={true}>
                                    <Input
                                        name="transportationLines"
                                        label={t("locations.transportationLines")}
                                        value={values.transportationLines}
                                        onChange={handleChange}
                                        error={formErrors?.transportationLines}
                                    />
                                </Field>
                                
                            </Row>
                            
                        </Form>
                    )}
                </Formik>
            </Main>
        </DefaultLayout>
    );
};

export default AddLocation;
